var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListLayout',{attrs:{"app-key":"jx3dat","app-name":"数据下载","without-right":true}},[_c('div',{staticClass:"m-userdata"},[_c('div',{staticClass:"m-plugins-header"},[_c('h1',{staticClass:"m-plugins-title"},[_c('i',{staticClass:"el-icon-user"}),_vm._v("用户配置数据")])]),_c('div',[_vm._v("即将登陆...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }